import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalService,
} from '@azure/msal-angular';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ToastModule } from '@usitsdasdesign/dds-ng/toast';
import { NgEventBus } from 'ng-event-bus';

import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { CSP_NONCE, importProvidersFrom, type ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { loadingInterceptor } from '@services/loading.interceptor';

import { extModules } from '../build-specifics';

import { routes } from './app.routes';
import {
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
} from './common/config/config.middleware';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    importProvidersFrom(
      BrowserModule,
      StoreModule.forRoot({}),
      EffectsModule.forRoot([]),
      MsalModule,
      extModules,
      ToastModule,
    ),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: CSP_NONCE,
      useValue: window.CONFIG_TRANSFER.NonceGuid,
    },
    MsalBroadcastService,
    MsalService,
    MsalGuard,
    NgEventBus,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([loadingInterceptor])),
    provideNoopAnimations(),
  ],
};
